import { injectIntl } from 'react-intl';
import Welcome from './Welcome';
import config from './config';

export const CONFIG = config;

export default injectIntl(Welcome);
